"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const core_1 = require("@material-ui/core");
const common_1 = require("../../../../utils/common");
require("./irs-form.scss");
const IrsForm = () => {
    const goToIrs9FormDocument = () => {
        if (common_1.ifMobile()) {
            //@ts-ignore
            cordova.InAppBrowser.open('https://www.irs.gov/pub/irs-pdf/fw9.pdf', '_system', 'location=no');
        }
        else {
            window.open('https://www.irs.gov/pub/irs-pdf/fw9.pdf', '_blank');
        }
    };
    return (react_1.default.createElement(react_1.Fragment, null,
        react_1.default.createElement(core_1.Box, { className: 'irs-container' },
            react_1.default.createElement("div", { className: 'irs-logo-section' },
                react_1.default.createElement("div", { className: 'irs-logo' }),
                react_1.default.createElement("div", { className: 'irs-text' })),
            react_1.default.createElement("div", { className: 'irs-form' },
                react_1.default.createElement("div", { className: 'info-message' }, "IRS Form W-9 is not complated."),
                react_1.default.createElement("p", null,
                    "Your earnings have reached $400. As required by law please submit your IRS W-9 form. ",
                    react_1.default.createElement("br", null),
                    "We need to collect this information to generate the appropriate tax forms. Your payouts may be withheld if any information is missing or incomplete."),
                react_1.default.createElement("button", { className: 'v2-btn v2-btn-primary', onClick: goToIrs9FormDocument }, "IRS W9 Form")))));
};
exports.default = IrsForm;
